/**
 * a11yTokens.js — Pure helper for deriving data-a11y token string
 *
 * [PURPOSE]: Central pure function consumed by BOTH:
 *   1. AppearanceController (sets document.documentElement attribute at runtime)
 *   2. The unit test (asserts correct token derivation without a DOM)
 *
 * [WHY extracted]: Rule 22 — never define an inline test replica of production
 *   logic. Extract → import in both production + test → assert.
 *
 * [TOKEN MAP]:
 *   dyslexiaFont  → "dyslexia"
 *   largeText     → "large-text"
 *   highContrast  → "high-contrast"
 *   reducedMotion → "reduced-motion"
 *
 * @param {Object} accessibility - The settings.accessibility object
 * @param {boolean} [accessibility.dyslexiaFont]
 * @param {boolean} [accessibility.largeText]
 * @param {boolean} [accessibility.highContrast]
 * @param {boolean} [accessibility.reducedMotion]
 * @returns {string} Space-joined token string, or '' when all flags are false/absent
 */
export function deriveA11yTokens(accessibility) {
  if (!accessibility || typeof accessibility !== 'object') return '';

  const tokens = [];
  if (accessibility.dyslexiaFont)  tokens.push('dyslexia');
  if (accessibility.largeText)     tokens.push('large-text');
  if (accessibility.highContrast)  tokens.push('high-contrast');
  if (accessibility.reducedMotion) tokens.push('reduced-motion');

  return tokens.join(' ');
}
